<div class="header-container">
    <span class="fs-20px font-weight-bold text-white">Nuevo Plan Protection</span>
    <span class="text-white fs-16px" style="cursor: pointer;" (click)="closeDialog()">
        <i class="fa-solid fa-square-xmark"></i>
    </span>
</div>
<div class="dialog-container">
    <form [formGroup]="proveedorForm">
        <div class="col-12 mb-2">
            <div class="nav-wizards-container">
                <nav class="nav nav-wizards-1 mb-2">
                  <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 1, 'completed': step > 1, 'disabled': step < 1}">
                      <div class="nav-no">1</div>
                      <div class="nav-text">Datos del Contrato</div>
                    </a>
                  </div>
                  <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 2, 'completed': step > 2, 'disabled': step < 2}">
                      <div class="nav-no">2</div>
                      <div class="nav-text">Datos del Cliente</div>
                    </a>
                  </div>

                  <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 3, 'completed': step > 3, 'disabled': step < 3}">
                      <div class="nav-no">3</div>
                      <div class="nav-text">Datos del Auto</div>
                    </a>
                  </div>

                  <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 4, 'completed': step > 4, 'disabled': step < 4}">
                      <div class="nav-no">4</div>
                      <div class="nav-text">Captura INE</div>
                    </a>
                  </div>
                  <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 5, 'completed': step > 5, 'disabled': step < 5}">
                      <div class="nav-no">5</div>
                      <div class="nav-text">Captura Tacómetro</div>
                    </a>
                  </div>
                  <div class="nav-item col">
                    <a class="nav-link " [ngClass]="{'active': step === 6, 'completed': step > 6, 'disabled': step < 6}">
                      <div class="nav-no">6</div>
                      <div class="nav-text">Firmar</div>
                    </a>
                  </div>
                  
                </nav>
            </div>             
        </div>
        <div class="col-12">
            
            <fieldset *ngIf="step === 1" class="mb-4 fieldset-container">
                <legend class="custom-legend">Datos de Contrato</legend>               

                <div class="row">

                    <!-- <div class="col-4">
                        <span class="fs-14px font-weight-bold">Folio</span>
                        <input class="form-control" formControlName="folio" type="text" />
                    </div> -->
                   
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Sucursal</span>
                        <input class="form-control"  formControlName="sucursal" type="text"/>
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Orden Venta</span>
                        <input class="form-control" formControlName="ordenVenta" type="text" />
                    </div>
                                 
                </div>
                <div class="row mb-2">
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Fecha Contratado</span>
                        <input class="form-control" formControlName="fechaContratado" type="text" />
                    </div>
                   
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Fecha Vigencia</span>
                        <input class="form-control"  formControlName="fechaVigencia" type="text"/>
                    </div>
                </div>
                
            </fieldset>

            <fieldset *ngIf="step === 2" class="mb-4 fieldset-container">
                
                <legend class="custom-legend mt-3">Datos de Cliente</legend>               

                <div class="row mb-2">
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Celular</span>
                        <input class="form-control"  formControlName="celularCliente" type="text"/>
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Nombre</span>
                        <input class="form-control" formControlName="nombreCliente" type="text" />
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Apellidos</span>
                        <input class="form-control"  formControlName="apellidosCliente" type="text"/>
                    </div>

                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">No. Cliente</span>
                        <input class="form-control"  formControlName="apellidosCliente" type="text"/>
                    </div>
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Correo</span>
                        <input class="form-control"  formControlName="correoCliente" type="text"/>
                    </div>

                </div>
                
            </fieldset>

            <fieldset *ngIf="step === 3" class="mb-4 fieldset-container">
                <legend class="custom-legend mt-3">Datos de Auto</legend>               

                <div class="row mb-2">
                    
                    <div class="col-12" [ngClass]="{'h-40px': auto.marca === 'Selecciona una marca', 'h-66px': auto.marca !== 'Selecciona una marca'}">
                        <div class="d-flex w-100 flex-column">
                            <span class="fs-14px font-weight-bold">Marca</span>
                            <div class="btn-group">
                                <span class="form-control dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img class="logo-marca" [src]="auto.logo" alt="">
                                    <span>{{auto.marca}}</span>
                                </span>
                                <ul class="dropdown-menu alto-maximo-dropdown">
                                    <li>
                                        <input type="text" formControlName="filtro" placeholder="Buscar marca...">
                                    </li>
                                    <li *ngFor="let marca of marcasFiltradas()" (click)="setCampoAuto('marca', marca.name, marca.slug, marca.logo)" class="d-flex flex-row">
                                        <img class="logo-marca" [src]="marca.logo" alt="">
                                        <span class="ms-2">{{marca.name}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                   
                    
                </div>

                
                 <div class="row mb-2">
                    
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Modelo</span>
                        <select class="form-control" name="model" id="model" [disabled]="modelDisabled" (change)="setCampoAuto('modelo', $event, $event)">
                            <option *ngFor="let model of modelos" [value]="model.name">{{model.name}}</option>
                        </select>
                    </div>
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Año</span>
                        <select class="form-control" name="cars" id="cars" [disabled]="yearDisabled" (change)="setCampoAuto('year', $event, $event)">
                            <option *ngFor="let year of years" [value]="year.name">{{year.name}}</option>
                        </select>
                    </div>


                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Kilometraje</span>
                        <input class="form-control" formControlName="kilometraje" type="text" />
                    </div>
                   
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">Placas</span>
                        <input class="form-control"  formControlName="placas" type="text"/>
                    </div>
                    
                    <div class="col-12">
                        <span class="fs-14px font-weight-bold">No. Serie</span>
                        <input class="form-control"  formControlName="noSerie" type="text"/>
                    </div>

                </div>
                
            </fieldset>

            <fieldset *ngIf="step === 4" class="mb-4 fieldset-container">
                <legend class="custom-legend">Captura de INE</legend>
                <app-webcam (imageCaptured)="onImage($event)"></app-webcam>

            </fieldset>

            <fieldset *ngIf="step === 5" class="mb-4 fieldset-container">
                <legend class="custom-legend">Captura de Tacómetro</legend>
                <app-webcam (imageCaptured)="onImage($event)"></app-webcam>
            </fieldset>
            
            <fieldset *ngIf="step === 6" class="mb-4 fieldset-container">
                <legend class="custom-legend">Firma</legend>
                <div (click)="abrirPdf()" class="d-flex flex-column align-items-center mt-2 mb-2">
                    <span>Da click aquí para previsualizar el documento.</span>
                    <i class="fa-solid fa-file-pdf fs-40px"></i>
                </div>
                <app-signature-pad (signatureSaved)="onSignature($event)"></app-signature-pad>
            </fieldset>

            <div class="d-flex flex-row justify-content-end">
                <button *ngIf="step > 1" (click)="nextStep(2)" class="btn btn-secondary">Regresar</button>
                <button *ngIf="step < 4" (click)="validateStep(1)" class="btn btn-primary ms-2">Continuar</button>
                <!-- <button *ngIf="step === 4" (click)="guardarProveedor()" class="btn btn-primary ms-2">Guardar Cambios a Proveedor</button> -->
            </div>
        </div>
    </form>
</div>